<template>
  <div
    class="bg-white relative rounded-2xl border grid gap-2 pb-2 shadow-md overflow-hidden"
  >
    <Top :data="data" :isCollection="isCollection" />
    <Post
      :class="{ lock: data.is_fake }"
      :data="data"
      :isCollection="isCollection"
    />
  </div>
</template>

<script>
import Post from "./Post";
import Top from "./Top";

export default {
  components: {
    Post,
    Top,
  },
  props: {
    data: Object,
    isCollection: Boolean,
    unlock: Boolean,
    lock: Boolean,
  },
};
</script>

<style>
.lock {
  filter: blur(12px);
  pointer-events: none;
}
</style>
